import React from "react";
import { FaEye, FaBullseye } from "react-icons/fa";

const VisionMission = () => {
  return (
    <section className="py-5">
      <div className="container">
        
        {/* Title */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">Our Vision & Mission</h2>
          <p className="text-muted">
            Driving excellence in every journey with Om Sai Cab Service
          </p>
        </div>

        <div className="row g-4">

          {/* Vision */}
          <div className="col-lg-6">
            <div
              className="p-4 shadow-lg h-100"
              style={{
                borderRadius: "18px",
                background: "#fff",
                borderTop: "4px solid #f9b800",
              }}
            >
              <div className="d-flex align-items-center mb-3">
                <div
                  className="me-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "#fff3cd",
                    color: "#f9b800",
                    fontSize: "22px",
                  }}
                >
                  <FaEye />
                </div>

                <h4 className="fw-bold mb-0">Our Vision</h4>
              </div>

              <p className="text-muted mb-0">
                To become the most trusted and preferred cab service provider
                by delivering safe, comfortable, and affordable travel
                experiences across cities and outstation routes.
              </p>
            </div>
          </div>

          {/* Mission */}
          <div className="col-lg-6">
            <div
              className="p-4 shadow-lg h-100"
              style={{
                borderRadius: "18px",
                background: "#fff",
                borderTop: "4px solid #000",
              }}
            >
              <div className="d-flex align-items-center mb-3">
                <div
                  className="me-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "#e9ecef",
                    color: "#000",
                    fontSize: "22px",
                  }}
                >
                  <FaBullseye />
                </div>

                <h4 className="fw-bold mb-0">Our Mission</h4>
              </div>

              <p className="text-muted mb-0">
                To provide reliable, punctual, and customer-focused cab services
                with professional drivers and well-maintained vehicles while
                ensuring complete satisfaction and safety for every ride.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default VisionMission;